import { useQuery } from '@apollo/client';
import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import StarfarmLogo from '../pictures/starfarmlogo.png';
import dashboad from "../pictures/dashboad.svg"
import star from "../pictures/star.svg"
import earning from "../pictures/earning.svg"
import headphone from "../pictures/headphone.svg"
import jobs from "../pictures/jobs.svg"
import approval from "../pictures/approval.svg"
import dashboadw from "../pictures/Dashboardw.svg"
import starw from "../pictures/Artistsw.svg"
import jobsw from "../pictures/jobw.svg"
import headphonew from "../pictures/Streamersw.svg"
import earningw from "../pictures/earnw.svg"
import approvalw from "../pictures/Approvalsw.svg"
import ProfileSettingsButton from './ProfileSettingsButton';
import totalNumberOfUser, {
  totalNumberOfUserResponse,
} from 'core/graphql/queries/totalNumberOfUsers';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PaymentIcon from '@material-ui/icons/Payment';
import EmailIcon from '@material-ui/icons/Email';
import FiberNewIcon from '@material-ui/icons/FiberNew';


const NavigationBar: FC = () => {
  const useStyles = makeStyles<Theme>((theme) => ({
    starFarmBackground: {
      position: 'relative',
      background: `url("${StarfarmLogo}")`,
      width: 64,
      height: 64,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderRadius: '50%',
      marginBottom: '14px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    navContainer: {
      paddingTop: theme.spacing(4.5),
      paddingBottom: theme.spacing(2.25),
    },
    menuOptions: {
      width: "100%",
      display: 'flex',
      alignItems: "center",
      position: "relative",
      left: "30px",
      marginBottom: '30px',
    },
    navLink: {
      color: 'rgba(240, 247, 255, 0.84)',
      marginLeft: '20px',
      lineHeight: 'none',
      fontSize: '18px',
      fontWeight: 500,
      '&:hover': {
        color: 'rgba(240, 247, 255, 0.84)',
        cursor: 'pointer',
      },
    },
    companyName: {
      color: '#f4f8ff',
      fontSize: '2rem',
      fontWeight: 300,
      letterSpacing: '0.08em',
      lineHeight: 1,
      marginBottom: 0,
    },
    wordmark: {
      width: 170,
      height: 'auto',
      marginBottom: 0,
    },
    adminTag: {
      color: '#8ea5bf',
      marginTop: 8,
      marginBottom: 30,
      fontSize: '0.72rem',
      letterSpacing: '0.08em',
      fontWeight: 700,
    },
    logOutBtn: {
      position: "absolute",
      bottom: '15px',
      width: "15%",
    },
    selected: {
      color: '#f7fbff',
      backgroundColor: 'rgba(112, 171, 196, 0.34)',
      borderRadius: 10,
    }
  }));

  const [selectedMenu, setSelectedMenu] = useState('')
  
  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/admin/emails')) {
      setSelectedMenu('communications');
      return;
    }
    setSelectedMenu(path.split("/")[1]);
  }, [])

  const classes = useStyles();
  // const { data, refetch } =
  //   useQuery<totalNumberOfUserResponse>(totalNumberOfUser);
  const history = useHistory();
  // React.useEffect(() => {
  //   refetch();
  // }, [refetch]);



  return (
    <nav>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        className={classes.navContainer}
      >
        <Box
          onClick={() => {history.push('/')
          setSelectedMenu('dashboard')
        }}
          className={classes.starFarmBackground}
        >
        </Box>
        <img
          src="https://starfarm-email-template-assets.s3.us-east-1.amazonaws.com/starfarm-wordmark.png"
          alt="starfarm"
          className={classes.wordmark}
        />
        <Typography className={classes.adminTag}>ADMIN</Typography>
        <Box className={selectedMenu === 'dashboard' ? classes.selected : " "} style={{
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
          width: 'calc(100% - 16px)',
        }}>
          <img src={selectedMenu === "dashboard" ? dashboadw : dashboad}>
          </img>
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "dashboard" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "dashboard" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('dashboard')
              history.push('/')
            }}
          >
            Dashboard
          </Typography>
        </Box>
        <Box className={selectedMenu === 'artist' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <img src={selectedMenu === 'artist' ? starw : star}>
          </img>
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "artist" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "artist" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('artist')
              history.push('/artist/?page=1')
            }}
          >
            Artists
          </Typography>
        </Box>
        <Box className={selectedMenu === "streamers" ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <img src={selectedMenu === "streamers" ? headphonew : headphone}>
          </img>
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "streamers" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "streamers" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('streamers')
              history.push('/streamers?page=1')
            }
            }
          >
            Streamers
          </Typography>
        </Box>
        <Box className={selectedMenu === 'earning' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <img src={selectedMenu === 'earning' ? jobsw : earning}>
          </img>
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "earning" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "earning" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('earning')
              history.push('/earning/?page=1&tab=1')
            }
            }
          >
            Earnings
          </Typography>
        </Box>
        <Box className={selectedMenu === 'jobs' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <img src={selectedMenu === 'jobs' ? earningw : jobs}>
          </img>
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "jobs" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "jobs" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('jobs')
              history.push('/jobs')
            }
            }
          >
            Scheduled Jobs
          </Typography>
        </Box>
        <Box className={selectedMenu === 'approval' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <img src={selectedMenu === 'approval' ? approvalw : approval}>
          </img>
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "approval" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "approval" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('approval')
              history.push('/approval/?tab=1')
            }
            }
          >
            Approvals
          </Typography>
        </Box>
        {/* SuperAdmin Section */}
        <Box className={selectedMenu === 'superadmin' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <SupervisorAccountIcon style={{ color: selectedMenu === "superadmin" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "superadmin" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "superadmin" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('superadmin')
              history.push('/superadmin')
            }
            }
          >
            SuperAdmin
          </Typography>
        </Box>
        {/* Affiliate Section */}
        <Box className={selectedMenu === 'affiliate' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <AttachMoneyIcon style={{ color: selectedMenu === "affiliate" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "affiliate" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "affiliate" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('affiliate')
              history.push('/affiliates')
            }
            }
          >
            Affiliate
          </Typography>
        </Box>
        {/* Home Heroes Section */}
        <Box className={selectedMenu === 'home-heroes' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <FiberNewIcon style={{ color: selectedMenu === "home-heroes" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "home-heroes" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "home-heroes" ? 700 : 500 }}
            onClick={() => {
              setSelectedMenu('home-heroes')
              history.push('/home-heroes')
            }}
          >
            Home Heroes
          </Typography>
        </Box>
        {/* Analytics Section */}
        <Box className={selectedMenu === 'admin-analytics' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <AssessmentIcon style={{ color: selectedMenu === "admin-analytics" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "admin-analytics" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "admin-analytics" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('admin-analytics')
              history.push('/admin-analytics')
            }
            }
          >
            Analytics
          </Typography>
        </Box>
        {/* Payout Management Section */}
        <Box className={selectedMenu === 'payout-management' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <PaymentIcon style={{ color: selectedMenu === "payout-management" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "payout-management" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "payout-management" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('payout-management')
              history.push('/payout-management')
            }
            }
          >
            Payout Management
          </Typography>
        </Box>
        {/* Conversions Section */}
        <Box className={selectedMenu === 'conversions' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <TrendingUpIcon style={{ color: selectedMenu === "conversions" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "conversions" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "conversions" ? 700 : 500 }}
            onClick={() => {
              
              setSelectedMenu('conversions')
              history.push('/conversions')
            }
            }
          >
            Conversions
          </Typography>
        </Box>
        <Box className={selectedMenu === 'communications' ? classes.selected : " "} style={{
          width: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: "center",
          position: "relative",
          paddingLeft: "26px",
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          marginLeft: '8px',
          marginRight: '8px',
        }}>
          <EmailIcon style={{ color: selectedMenu === "communications" ? '#f7fbff' : 'rgba(224, 236, 248, 0.82)', marginRight: '10px' }} />
          <Typography
            className={classes.navLink}
            variant="h4"
            style={{ color: selectedMenu === "communications" ? '#f7fbff' : 'rgba(240, 247, 255, 0.84)', fontWeight: selectedMenu === "communications" ? 700 : 500 }}
            onClick={() => {
              setSelectedMenu('communications')
              history.push('/admin/emails')
            }}
          >
            Communications
          </Typography>
        </Box>
        <Box className={classes.logOutBtn}>
          <ProfileSettingsButton />
        </Box>
      </Box>
    </nav>
  );
};

export default NavigationBar;
